<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <div class="row">
                <div class="col-6">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }" >
                        <b-form-group :label="$t('type')">
                            <parameter-selectbox v-model="form.type" :code="'page_message_types'" :validate-error="errors[0]" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="path" rules="" v-slot="{ valid, errors }" >
                        <b-form-group :label="$t('pathname')">
                            <b-form-input v-model="form.path"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="faculty_code" rules="" v-slot="{valid, errors}">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="form.faculty_code"
                                               :multiple="true"
                                               :validate-error="errors[0]"/>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-4">
                  <ValidationProvider name="department_code" rules="" v-slot="{valid, errors}">
                      <b-form-group :label="$t('department')">
                          <department-selectbox v-model="form.department_code"
                                                :faculty_code="form.faculty_code"
                                                :multiple="true"
                                                :validate-error="errors[0]"/>
                      </b-form-group>
                  </ValidationProvider>
                </div>
                <div class="col-4">
                    <ValidationProvider name="program_code" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('program')">
                            <program-selectbox v-model="form.program_code" :faculty_code="form.faculty_code"
                                               :department_code="form.department_code"
                                               :multiple="true" :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="roles" rules="" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('roles')">
                            <role-selectbox :valueType="'name'" :multiple="true" v-model="form.roles"
                                            :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="filter" rules="" v-slot="{ valid, errors }" >
                        <b-form-group :label="$t('filter')">
                            <b-form-input v-model="form.filter"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="message" rules="" v-slot="{ valid, errors }" >
                        <b-form-group :label="$t('message')">
                            <b-form-textarea v-model="form.message"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="message_en" rules="" v-slot="{ valid, errors }" >
                        <b-form-group :label="$t('message_en')">
                            <b-form-textarea v-model="form.message_en"></b-form-textarea>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" ></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </div>
                <div class="col-6">
                    <ValidationProvider name="status" rules="" v-slot="{valid, errors}">
                        <b-form-select v-model="form.status" :options="[{ text: $t(`active`), value: '1' }, { text: $t(`passive`), value: '0' }]" />
                    </ValidationProvider>
                </div>
            </div>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex">
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
    //Component
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import PageMessagesService from "@/services/PageMessagesService";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox.vue";

    export default {
        components: {
            StatusSelectbox,
            ValidationProvider, ValidationObserver,
        },
        data() {
            return {
                formLoading: false,
                form: {
                    type: null,
                    path: null,
                    faculty_code: null,
                    department_code: null,
                    program_code: null,
                    roles: null,
                    filter: null,
                    message: null,
                    message_en: null,
                    status: null,
                }
            }
        },
        methods: {
            async createForm() {
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    this.formLoading = true;
                    PageMessagesService.store(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                    })
                                    .catch((error) => {
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    }).finally(() => {
                        this.formLoading = false;
                    });
                }
            }
        }
    }
</script>
